export default __webpack_public_path__ + "static/media/Q.bc67242a.png";